import { Component, ElementRef, OnInit } from '@angular/core';
import { Subject, take, takeUntil} from "rxjs";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { EmployeeRoleEnum } from "../../../enums/employee-role.enum";
import { DropdownHelperModel } from "../../../models/helpers/dropdown-helper.model";
import { AddOrEditEmployeeModel } from "../../../models/employees/add-or-edit-employee.model";
import { TranslateService } from "@ngx-translate/core";
import { CompressImageService } from "../../../../share-modul/services/common/compress-image.service";
import { MessageService } from "primeng/api";
import { EmployeeService } from "../../../services/employees/employe.service";

@Component({
  selector: 'app-add-or-edit-employee',
  templateUrl: './add-or-edit-employee.component.html',
  styleUrls: ['./add-or-edit-employee.component.scss']
})
export class AddOrEditEmployeeComponent implements OnInit {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>();
  public pictureIsWrongFormat: boolean = false;
  public employeeModel: AddOrEditEmployeeModel = new AddOrEditEmployeeModel();
  public filePicture: any;
  public pictureFormat: Array<string>;
  public imagePath: string = './assets/images/logo/profile-picture-placeholder.png';
  public errorModel: { [k: string]: any } = {};
  public spinner: boolean = false;
  public employeeId: string;
  public employeeRoleEnum = EmployeeRoleEnum;
  public enableEdit: boolean = false;
  public rolesDropdownHelperModels: Array<DropdownHelperModel>;
  public requiredFieldErrorMessage = "INFO.REQUIRED_FIELD";
  //#endregion

  //#region Constructor
  constructor(private openFile: ElementRef,
              private config: DynamicDialogConfig,
              private ref: DynamicDialogRef,
              private employeeService: EmployeeService,
              private messageService: MessageService,
              private compressImage: CompressImageService,
              public translate: TranslateService) {
    this.employeeModel = new AddOrEditEmployeeModel();

    if (this.config.data != undefined && this.config.data.employeeId) {
      this.employeeId = this.config.data.employeeId;
      this.enableEdit = true;
      this.getEmployeeById(this.employeeId);
    }

    this.pictureFormat = ['image/png', 'image/jpg', 'image/jpeg'];

    this.rolesDropdownHelperModels = new Array<DropdownHelperModel>();

    Object.keys(EmployeeRoleEnum).filter(e => !isNaN(+e)).forEach(role => {
      let option = new DropdownHelperModel()
      option.id = +role;
      option.name = this.translate.instant('EMPLOYEES.' + EmployeeRoleEnum[+role].toUpperCase());
      this.rolesDropdownHelperModels.push(option);
    });
  }

  ngOnInit(): void {
  }
  //#endregion

  //#region Public Methods
  addEmployee(model: AddOrEditEmployeeModel) {
    this.errorModel = {};
    model.languageId = this.languageIdFromLocalStorage();

    if (model && (!model.firstName || model.firstName == "")) {
      this.errorModel['FirstName'] = this.requiredFieldErrorMessage;
    }
    if (model && (!model.lastName || model.lastName == "")) {
      this.errorModel['LastName'] = this.requiredFieldErrorMessage;
    }
    if (model && (!model.email || model.email == "")) {
      this.errorModel['Email'] = this.requiredFieldErrorMessage;
    }
    if (model && (!model.phone || model.phone == "")) {
      this.errorModel['Phone'] = this.requiredFieldErrorMessage;
    }
    if (model && (!model.address || model.address == "")) {
      this.errorModel['Address'] = this.requiredFieldErrorMessage;
    }
    if (model && !model.venueEmployeeTypeId) {
      this.errorModel['Role'] = this.requiredFieldErrorMessage;
    }
    if (!this.errorModel['FirstName'] && !this.errorModel['LastName'] && !this.errorModel['Email']
      && !this.errorModel['Phone'] && !this.errorModel['Address']) {
      this.spinner = true;
      this.employeeModel.phone = this.employeeModel.phone.toString();
      if (model.venueEmployeeTypeId === EmployeeRoleEnum.Waiter) {
        this.employeeService.registerWaiter(model, this.filePicture)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe({
            next: (response) => {
              this.spinner = false;
              this.ref.close(true)
            },
            error: errorResponse => {
              this.spinner = false;
              if (errorResponse.error.StatusCode == -301) {
                this.messageService.add({ severity: 'error', summary: this.translate.instant('INFO.USER_EXISTS'), life: 2000 });
              } else {
                this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
              }
            }
          });
      } else {
        this.employeeService.registerManager(model, this.filePicture)
          .pipe(takeUntil(this.unsubscribe))
          .subscribe({
            next: (response) => {
              this.spinner = false;
              this.ref.close(true)
            },
            error: errorResponse => {
              this.spinner = false;
              if (errorResponse.error.StatusCode == -301) {
                this.messageService.add({ severity: 'error', summary: this.translate.instant('INFO.USER_EXISTS'), life: 2000 });
              } else {
                this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
              }
            }
          });
      }
    }
  }

  updateEmployee(model: AddOrEditEmployeeModel) {
    this.errorModel = {};
    model.languageId = this.languageIdFromLocalStorage();

    if (model && (!model.firstName || model.firstName == "")) {
      this.errorModel['FirstName'] = this.requiredFieldErrorMessage;
    }
    if (model && (!model.lastName || model.lastName == "")) {
      this.errorModel['LastName'] = this.requiredFieldErrorMessage;
    }
    if (model && (!model.email || model.email == "")) {
      this.errorModel['Email'] = this.requiredFieldErrorMessage;
    }
    if (model && (!model.phone || model.phone == "")) {
      this.errorModel['Phone'] = this.requiredFieldErrorMessage;
    }
    if (model && (!model.address || model.address == "")) {
      this.errorModel['Address'] = this.requiredFieldErrorMessage;
    }
    if (model && !model.venueEmployeeTypeId) {
      this.errorModel['Role'] = this.requiredFieldErrorMessage;
    }
    if (!this.errorModel['FirstName'] && !this.errorModel['LastName'] && !this.errorModel['Email']
      && !this.errorModel['Phone'] && !this.errorModel['Address']) {
      this.spinner = true;
      this.employeeService.updateEmployee(model, this.filePicture)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.spinner = false;
            this.ref.close(true)
          },
          error: errorResponse => {
            this.spinner = false;
            this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
          }
        });
    }
  }

  generatePin() {
    this.spinner = true;
    this.employeeService.generateNewPin()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.employeeModel.pin = response;
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
        }
      });
  }

  getEmployeeById(employeeId: string) {
    this.spinner = true;
    this.employeeService.getEmployeeDetails(employeeId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.spinner = false;
          this.employeeModel = response;
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
        }
      });
  }

  cancel(): void {
    this.ref.close(false);
  }

  openAddImage(): void {
    var element = this.openFile.nativeElement.querySelector(".open-file");
    element.click();
  }

  onFileSelected(event: any): void {
    this.pictureIsWrongFormat = false;
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      if (!this.pictureFormat.includes(event.target.files[0].type)) {
        this.pictureIsWrongFormat = true;
        return;
      }
      let image: File = event.target.files[0]
      reader.readAsDataURL(image);// read file as data url
      this.compressImage.compress(image)
        .pipe(take(1))
        .subscribe(compressedImage => {
          this.filePicture = compressedImage;
        })
      reader.onload = (item) => { // called once readAsDataURL is completed
        if (item.target?.result) {
          this.employeeModel.pictureUrl = item.target?.result as string;
        }
      }
    }
  }

  languageIdFromLocalStorage(): number {
    const langIdFromStorage = localStorage.getItem('languageId');

    if (langIdFromStorage) {
      return parseInt(langIdFromStorage);
    } else {
      return 1;
    }
  }

  determineImageForEmployee(pictureUrl: string) {
    const image = pictureUrl ? pictureUrl : this.imagePath;
    return encodeURI(image);
  }

  employeeHasPIN(pin: string): boolean {
    return pin !== undefined && pin !== null && (!(pin === '0000') && !(pin.trim() === ''));
  }
  //#endregion
}
